const formatId = (prefix: "ACC-" | "AST-" | "LIQ-" | "USR-" | "INV-", id: number | string) => {
  return typeof id === "number" ? prefix + "0".repeat(6 - String(id).length) + id : id;
};

export default formatId;
